import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import NavBar from '../features/commons/NavBar';
import Sidebar from '../features/commons/Sidebar';
import { ResetUser, setAppVersion } from '../features/auth/store/actions';
import { hardResetKpiState } from '../features/kpi/store/actions';

function PrivateRoute({ children }) {
  const user = useSelector((state) => state.auth);
  const [expanded, setExpanded] = useState(false);
  const dispatch = useDispatch();
  if (!user || !user.data || !user.data.token) {
    return <Navigate to='/auth' replace />
  }
  return (
    <div className='d-flex flex-column'>
      <NavBar />
      <div className={`layout-container${expanded ? ' expanded' : ' collapsed'}`}>
        <Sidebar expanded={expanded} onExpandClick={() => setExpanded(!expanded)} />
        {children}
      </div>
    </div>
  );
}

export default PrivateRoute;
